module.exports = __webpack_public_path__ + "static/media/eats-free-share-badge.44f5788a.png";